import React, { useState } from "react";
import "./Footer.scss";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from "react-i18next";
import PaylaterLogo from "@assets/img/paylater-logo.svg";
import UzFlag from "@assets/img/uzFlag.png";
import RussianFlag from "@assets/img/russianFlag.png";
import telegram from "@assets/img/telegram.svg";
import letterIcon from "@assets/img/letter_icon.svg";
import inst from "@assets/img/inst.svg";
import phoneIcon from "@assets/img/phone_icon.svg";
import { useGlobalState } from "@/context/GlobalStateContext";
import infoMFODoc from "@assets/documents/МФО.jpg";
import { trackEvent } from "@/utils/analytics";
import mfoOfertaActual from "@assets/documents/30_04_2026_MFO_OFERTA_ACTUAL.pdf";
import paylaterFinanceOffer from "@assets/documents/9_07_2026_PAYLATER_FINANCE_NEW.pdf";

import Alert from "../Custom/Alert";
import googlePlay from "@assets/img/googlePlay.svg";
import appStore from "@assets/img/appStore.svg";
import { socialMediaLinks } from "../../consts/socialMediaLinks";

function Footer() {
  const { language, setLanguage, siteVersion, setSiteVersion } =
    useGlobalState();
  const { t: tCommon } = useTranslation(["common"]);
  const { t: tSiteVersion } = useTranslation([`${siteVersion}`]);
  const [alertVisible, setAlertVisible] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText("+998781137077");
      trackEvent("contact_us_click", {
        method: "phone_copy",
        value: "+998781137077",
        source: "footer",
      });
      setAlertVisible(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-head-block">
          <img src={PaylaterLogo} alt="paylater-logo" />
          {language === "ru" ? (
            <button className="mob-btn" onClick={() => setLanguage("uz")}>
              <img
                src={UzFlag}
                alt="uz-flag"
                className="lang-icon"
                draggable="false"
              />
              UZ
            </button>
          ) : (
            <button className="mob-btn" onClick={() => setLanguage("ru")}>
              <img
                src={RussianFlag}
                alt="uz-flag"
                className="lang-icon"
                draggable="false"
              />
              RU
            </button>
          )}
        </div>

        <div className="footer-info-block">
          <div className="nav-links">
            <div className="nav-label">Paylater</div>
            <div className="footer-anchor anchor-link">
              <ScrollLink to="benefits" smooth>
                {tCommon("anchors.benefits")}
              </ScrollLink>
            </div>
            {/* <div className="footer-anchor anchor-link">
              <ScrollLink to="partner-shops" smooth>
                {tCommon("anchors.partnerShops")}
              </ScrollLink>
            </div> */}
            <div className="footer-anchor anchor-link">
              <ScrollLink to="banner" smooth>
                {tCommon("anchors.banner")}
              </ScrollLink>
            </div>
            <div className="footer-anchor anchor-link">
              <ScrollLink to="howItWork" smooth>
                FAQ
              </ScrollLink>
            </div>

            {siteVersion === "client" ? (
              <div
                className="footer-anchor anchor-link"
                onClick={() => setSiteVersion("business")}
              >
                {tSiteVersion("button.text")}
              </div>
            ) : (
              <div
                className="footer-anchor anchor-link"
                onClick={() => setSiteVersion("client")}
              >
                {tSiteVersion("button.text")}
              </div>
            )}
          </div>

          <div className="nav-links">
            <div className="nav-label">{tCommon("address.title")}</div>
            <div
              className="footer-anchor"
              dangerouslySetInnerHTML={{ __html: tCommon("address.text") }}
            />

            <div className="nav-label section-label">
              {tCommon("mobileApplication.title")}
            </div>
            <div id="mobile-apps" className="store-buttons">
              <a
                href="https://play.google.com/store/apps/details?id=com.paylateruz"
                className="store-button"
              >
                <img
                  src={googlePlay}
                  alt="google-play"
                  className="store-icon"
                />
                <div className="store-text">
                  <span className="small">
                    {tCommon("downloadFromGooglePlay.title")}
                  </span>
                </div>
              </a>

              <a
                href="https://apps.apple.com/uz/app/paylater-muddatli-to-lov/id6752317073"
                className="store-button"
              >
                <img src={appStore} alt="app-store" className="store-icon" />
                <div className="store-text">
                  <span className="small">
                    {tCommon("downloadFromAppStore.title")}
                  </span>
                </div>
              </a>
            </div>
          </div>
          <div className="nav-links">
            <div className="nav-label">{tCommon("documents.title")}</div>
            <div className="footer-anchor anchor-link">
              <a
                href={mfoOfertaActual}
                target="_blank"
                rel="noopener noreferrer"
              >
                {tCommon("publicOffer.title")}
              </a>
            </div>
            <div className="footer-anchor anchor-link">
              <a
                href={paylaterFinanceOffer}
                target="_blank"
                rel="noopener noreferrer"
              >
                {tCommon("publicOfferNew.title")}
              </a>
            </div>

            <div className="footer-anchor anchor-link">
              <a href="/privacy-policy">{tCommon("conf.title")}</a>
            </div>

            <div className="footer-anchor anchor-link">
              <a href="/archive" rel="noreferrer">
                {tCommon("specialOffers.title")}
              </a>
            </div>
            <div className="footer-anchor anchor-link">
              <a href={infoMFODoc} rel="noreferrer">
                {tCommon("infoMFO.title")}
              </a>
            </div>
          </div>

          <div className="nav-links">
            <p className="footer-contact__title">
              {tCommon("connection.title")}
            </p>

            <div className="footer-contact footer-contact--icons">
              {/* Телефон */}
              <div
                className="footer-contact__row --mobileTel anchor-link"
                onClick={() => {
                  trackEvent("contact_us_click", {
                    method: "phone_call",
                    value: "+998781137077",
                    source: "footer",
                  });
                  window.location.href = "tel:+998781137077";
                }}
              >
                <img
                  src={phoneIcon}
                  alt="phone-icon"
                  className="footer-contact__icon"
                />
                <span className="footer-contact__link">+998 78 113 70 77</span>
              </div>

              <div
                className="footer-contact__row --desctopTel anchor-link"
                onClick={handleCopy}
              >
                <img
                  src={phoneIcon}
                  alt="phone-icon"
                  className="footer-contact__icon"
                />
                <span className="footer-contact__link">+998 78 113 70 77</span>
              </div>

              {/* телега */}
              <a
                href="https://t.me/paylateruz_bot"
                target="_blank"
                rel="noreferrer"
                className="footer-contact__row"
                onClick={() =>
                  trackEvent("contact_us_click", {
                    method: "telegram",
                    value: "@paylateruz_bot",
                    source: "footer",
                  })
                }
              >
                <img
                  src={telegram}
                  alt="telegram-icon"
                  className="footer-contact__icon"
                />
                <span className="footer-contact__link">@paylateruz_bot</span>
              </a>

              {/* мыло */}
              <a href="mailto:info@paylater.uz" className="footer-contact__row">
                <img
                  src={letterIcon}
                  alt="email-icon"
                  className="footer-contact__icon"
                />
                <span className="footer-contact__link">info@paylater.uz</span>
              </a>
            </div>

            <Alert
              message={tCommon("copy_message")}
              visible={alertVisible}
              onClose={() => setAlertVisible(false)}
            />

            <div className="nav-label">{tCommon("socials.title")}</div>
            <div className="d-flex-start-center">
              <a
                style={{ marginLeft: -3 }}
                href={socialMediaLinks.instagram}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  trackEvent("contact_us_click", {
                    method: "instagram",
                    value: socialMediaLinks.instagram,
                    source: "footer",
                  })
                }
              >
                <img alt="inst" src={inst} />
              </a>
              <a
                href={socialMediaLinks.telegram}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  trackEvent("contact_us_click", {
                    method: "telegram",
                    value: socialMediaLinks.telegram,
                    source: "footer",
                  })
                }
              >
                <img alt="telegram" src={telegram} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
